import Vue from 'vue'
import BudgetTransformer from '@/transformers/purchase/budget'
import errorHandler from '@/utils/errorHandler'

export default (budget) => {
  const payload = BudgetTransformer.send(budget)

  const request = Vue.$http.post('purchase/budget/', payload)
  return errorHandler(request)
    .then((response) => {
      const data = response.data
      return data
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/sendBudget.js